import { cn } from "@/shared/lib/utils";
import React from "react";


interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = "md",
  className 
}) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6", 
    lg: "h-8 w-8"
  };

  return (
    <div
      className={cn("flex items-center justify-center", className)}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div
        className={cn(
          "animate-spin rounded-full border-2 border-slate-300 border-t-slate-600",
          sizeClasses[size]
        )}
      />
    </div>
  );
};
